<template>
	<div class='slider_box' v-if="pages.length>0">
		
		<slider ref="slider" :options="sliderinit">
            <!-- slideritem wrapped package with the components you need -->
            <slideritem v-for="(item,index) in pages" :key="index" :style="item.style">{{item.title}}</slideritem>
            <!-- Customizable loading -->
            <div slot="loading">loading...</div>
	    </slider>
	    <div class="btn slidePre" v-on:click="slidePre"><i class="iconfont icon-left"></i></div>
	    <div class="btn slideNext" v-on:click="slideNext"><i class="iconfont icon-right"></i></div>
	</div>
	
</template>

<script>
	import company_product_introductionJs from './company_product_introduction.js';
	export default company_product_introductionJs;
</script>

<style>
	.slider_box{
		width: 100%;
		height: 100%;
		z-index: 2;
		position: relative;
	}
	.btn{
		background: #C4A174;
		color: #fff;
		width: 20px;
		height: 100px;
		position: absolute;
		top: 35%;
		z-index: 10;
		text-align: center;
	}
	.btn>i{
		font-size: larger;
		font-weight: 800;
		line-height: 100px;
	}
	.slidePre{
		left: 10%;
	}
	.slideNext{
		right: 5%;
	}
</style>


// WEBPACK FOOTER //
// src/components/company_product_introduction/company_product_introduction.vue